import React, { useRef } from "react";
import Constants from "../../../Constants";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import DatePickerCalendar from "../../dashboard/calendars/DatePickerCalendar";
import APIUrls from "../../../services/APIUrls";
import { putAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import { TIME_LIST,transformBlankToNull,checkUpdateBidDateDisabledCondition,disabledSelectStyle} from '../../../services/Util';
import Select from "react-select";
import { calenderIcon, CrossIconForModal, SuccessTick } from "../../../AppIcons";
import dateUtil, {DATE_FORMATS} from "../../../services/DateUtil";
import moment from "moment/moment";
import DateFormat from "../../../pages/DateFormat";

export default function EditProjectDateBid(prop) {
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [errorData, setErrorData] = useState([]);
  const [receiveQuotes, setReceiveQuotes] = useState(true);
  const [autoVendorApprove, setAutoApproveVendor] = useState("");
  const [toggle, toggleCal] = useState(false);
  const [bidDueDate, setBidDueDate] = useState(null);
  const [deliveryDueDate, setDeliveryDueDate] = useState(null);
  const [minDeliveryDueDate, setMinDeliveryDueDate] = useState(null);
  const [autoVendorsSelected, setAutoVendor] = useState("");
  const [bidDueTime, setBidDueTime] = useState(-1);
  const [deliveryDueTime, setDeliveryDueTime] = useState(-1);
  const [toggleIntialCal, toggleIntialCalFlag] = useState(false);
  const [bidSelectDeadlineDate, setBidSelectDeadlineDate] = useState(null);

  const project = Object.assign({}, prop.projectResource);
  const projectStatus = prop.projectStatus;
  const preferedVendors = prop.preferVendor;
  const allowAutomaticSelect = prop.autoSelect;
  const refToggle = useRef(null);
  const refToggle2 = useRef(null);
  const refCalendar = useRef(null);
  const refCalendar2 = useRef(null);
  const closeCalendar = (e) => {
    if (e.code === Constants.ESCAPE) {
      if ($('.cal-firstFocus').length) {
        setTimeout(() => {
          toggleCal(false);
          $('.cal-firstFocus').trigger('focus')
          $('#cal-firstFocus').removeClass('cal-firstFocus')
        }, 100);
      } else if ($('.cal-secondFocus').length) {
        setTimeout(() => {
        toggleIntialCalFlag(false);
        $('.cal-secondFocus').trigger('focus')
        $('#cal-secondFocus').removeClass('cal-secondFocus')
      }, 100);
      }
    }
  };
  
const closePopup = () =>{
    setErrorData([])
    toggleCal(false)
    setAutoApproveVendor("")
    setSelectedVendors([])
    prop.close()
} 
  const isBiddingEnabled = () => {
    return (
      project.projectVendorType !== "INTERNAL" &&
      project.projectVendorType !== "MACHINE_TRANSLATION" &&
      project.projectVendorType !== "EXTERNAL_BIDLESS"
    );
  };
  const selectVendor = (vendor) => {
    $(document.activeElement).attr("aria-checked", function(index, value) {
        return value === "true" ? "false" : "true";
      });
    var alreadyEsistes = selectedVendors.filter((selectedeVendors) => {
      return selectedeVendors.id == vendor.id;
    });
    if (alreadyEsistes.length > 0) {
      setSelectedVendors(
        selectedVendors.filter((selectedeVendors) => {
          return selectedeVendors.id != vendor.id;
        })
      );
    } else {
      setSelectedVendors((current) => [...current, vendor]);
    }
  };
  const autoBidApproveSelect = (e) => {
    if (e.target.checked) {
      setAutoApproveVendor(true);
    } else {
      setAutoApproveVendor(false);
    }
  };
  const showCalendarDueDate = () => {
    toggle ? toggleCal(false) : toggleCal(true);
    $(document.activeElement).toggleClass('cal-firstFocus');
    $('.cal-firstFocus').trigger('focus');
    $(document).mouseup(function(e) {
      var bannerCont = $('.firstCal');
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        toggleCal(false);
        $('.cal-firstFocus').removeClass('cal-firstFocus');
     }
    });
    if (toggle) {
      var requiredElement = document.querySelector(".dashCalendar");
      if (requiredElement !== null) {
        requiredElement.focus();
      }
    }
    $("#submit-quotes .gb-dropBtn").toggleClass("calenderbtn1");
  };

  const initMinDeliveryDueDate = () => {
    let minDate = moment(bidDueDate).add(4, "hours");
    if(minDate.hours() > 17) {
      minDate = minDate.add(1, "days");
      minDate.set({
        'hour': 0,
        'minute': 0,
        'second': 0,
        'millisecond': 0,
      });
    }
    setMinDeliveryDueDate(minDate.valueOf());
  }

  const bumpDeliveryDueDate = () => {
    if (moment(minDeliveryDueDate).isAfter(moment(deliveryDueDate), "hours")) {
      var nextDayDate = moment(bidDueDate).add(1, 'days');
      nextDayDate.set({
        'hour': 17, // 5 PM fixed
        'minute': 0,
        'second': 0,
        'millisecond': 0,
      });
      setDeliveryDueDate(nextDayDate.valueOf());
      setDeliveryDueTime(nextDayDate.hours());
    }
  }

  const bidDueDateChangeHandler = (event) => {
    let newBidDueDate = new Date(event).setHours(bidDueTime)
    setBidDueDate(newBidDueDate);
    $('.cal-firstFocus').trigger('focus')
    $('#cal-firstFocus').removeClass('cal-firstFocus')
    $(document).mouseup(function(e) {
      var bannerCont = $('.cal-firstFocus');
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        $('.cal-firstFocus').trigger('focus')
        $('#cal-firstFocus').removeClass('cal-firstFocus')
      }
    });
    toggleCal(false);
  };

  const bidDueTimeChangeHandler = (event) => {
    let hour = parseInt(event.value);
    var newBidDueDate = moment(bidDueDate)
    newBidDueDate.set({
      'hour': hour,
      'minute': 0,
      'second': 0,
      'millisecond': 0,
    })
    setBidDueDate(newBidDueDate.valueOf());
    setBidDueTime(hour);
  }
  const deliveryDueTimeChangeHandler = (event) => {
    let hour = parseInt(event.value);
    var newDeliveryDueDate = moment(deliveryDueDate)
    newDeliveryDueDate.set({
      'hour': hour,
      'minute': 0,
      'second': 0,
      'millisecond': 0,
    })
    setDeliveryDueDate(newDeliveryDueDate.valueOf());
    setDeliveryDueTime(hour);
  }
  const showCalendarDeliveryDate = () => {
    toggleIntialCal ? toggleIntialCalFlag(false) : toggleIntialCalFlag(true);
    $(document.activeElement).toggleClass('cal-secondFocus');
    $('.cal-secondFocus').trigger('focus');
    $(document).mouseup(function(e) {
      var bannerCont = $('.caltopset');
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        toggleIntialCalFlag(false);
        $('.cal-secondFocus').removeClass('cal-secondFocus');
     }
     });
    if (toggleIntialCal) {
      var requiredElement = document.querySelector(".dashCalendar2");
      if (requiredElement !== null) {
        requiredElement.focus();
      }
    }
    $("#initial-translation .gb-dropBtn").toggleClass("calenderbtn2");
    $(document).mouseup(function (e) {
      var bannerCont = $(".calenderbtn2");
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        $(".calenderbtn2").trigger("click");
      }
    });
  };
  const setDeliveryDate = (event) => {
    let newDeliveryDueDate = new Date(event).setHours(deliveryDueTime)
    setDeliveryDueDate(newDeliveryDueDate);
    $('.cal-secondFocus').trigger('focus');
    $('#cal-secondFocus').removeClass('cal-secondFocus');
    $(document).mouseup(function(e) {
      var bannerCont = $('.cal-secondFocus');
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        $('.cal-secondFocus').trigger('focus');
        $('#cal-secondFocus').removeClass('cal-secondFocus');
      }
    });
    toggleIntialCalFlag(false);
  };

  const calculateBidSelectionDeadline = () => {
    var differenceInHours = moment(deliveryDueDate).diff(bidDueDate, "hours");

    differenceInHours = differenceInHours * 0.25;

    var hoursToAddToBidDueDate = Math.abs(differenceInHours);

    if (hoursToAddToBidDueDate < 2) {
      hoursToAddToBidDueDate = 2;
    }

    var updatedDate = new Date(bidDueDate).setHours( new Date(bidDueDate).getHours() + hoursToAddToBidDueDate );
    setBidSelectDeadlineDate(updatedDate);
    return updatedDate;
  };
  const updateAgain = (event) => {
    let allAreFalse = true;
    $('.small-dropdown-select').each(function() {
      if ($(this).find('input').attr('aria-expanded') !== 'false') {
        allAreFalse = false;
        return false;
      }
    });
    if(event.key === Constants.TAB && !event.shiftKey) {
      if ($(event.target).attr('id') === 'confirmProjectDateBid' ||
          (($(event.target).attr('id') === 'cancelProjectDateBid') &&
          $('#confirmProjectDateBid').prop('disabled'))) {
          event.preventDefault();
          $('.close').trigger('focus');
      }
    } else if (event.key === Constants.TAB && event.shiftKey) {
      if (($(event.target).attr('id') === 'close') && $('#confirmProjectDateBid').prop('disabled')) {
        event.preventDefault();
        $('#cancelProjectDateBid').trigger('focus');
      } else if ($(event.target).attr('id') === 'close') {
        event.preventDefault();
        $('#confirmProjectDateBid').trigger('focus');
      }
    } else if (event.key === Constants.ESCAPE
      && allAreFalse
      && !($('.cal-firstFocus').length) &&
      !($('.cal-secondFocus').length)) {
      closePopup();
      $('.focusAdd').trigger('focus');
      $('.showPopup').removeClass('focusAdd');
    }
  }

  useEffect(() => {
    if(!bidDueDate || !deliveryDueDate) {
      const bidDueDateTimestamp = dateUtil.convertToLocalDateTimestamp(project?.bidDueDate);
      const deliveryDueDateTimestamp = dateUtil.convertToLocalDateTimestamp(project?.deliveryDueDate);
      const bidSelectDeadlineDateTimestamp = dateUtil.convertToLocalDateTimestamp(project?.bidSelectDeadlineDate);
      setBidDueDate(bidDueDateTimestamp);
      setDeliveryDueDate(deliveryDueDateTimestamp);
      setBidSelectDeadlineDate(bidSelectDeadlineDateTimestamp);
      setBidDueTime(moment(bidDueDateTimestamp).hours());
      setDeliveryDueTime(moment(deliveryDueDateTimestamp).hours());
    }
  }, [project])

  useEffect(() => {
    if(bidDueTime !== -1 || bidDueDate !== "" || deliveryDueDate !== "" || deliveryDueTime !== -1) {
      calculateBidSelectionDeadline();
    }
  }, [bidDueTime, bidDueDate, deliveryDueDate, deliveryDueTime]);

  useEffect(() => {
    if(bidDueDate) {
      initMinDeliveryDueDate();
    }
  }, [bidDueTime, bidDueDate]);

  useEffect(() => {
    bumpDeliveryDueDate();
  }, [minDeliveryDueDate]);

  useEffect(() => {
    if(moment(deliveryDueDate).isBefore(minDeliveryDueDate)) {
      setDeliveryDueDate(minDeliveryDueDate);
      setDeliveryDueTime(moment(minDeliveryDueDate).hours());
    }
  }, [deliveryDueDate])

  const updateBidDate = () => {
    var error = {
      bidDueDate: "",
      deliveryDueDate: "",
      vendor: "",
    };
    if (!bidDueDate) {
      error.bidDueDate = "error";
      setErrorData(error);
      $('#cal-firstFocus').trigger('focus');
    }
    if (!deliveryDueDate) {
      error.deliveryDueDate = "error";
      setErrorData(error);
      $('#cal-secondFocus').trigger('focus');
    }
    if (selectedVendors.length === 0) {
      error.vendor = "error";
      setErrorData(error);
      $('.vender-outer .translate-box-list:first a').trigger('focus');
    }
    if (bidDueDate && deliveryDueDate && selectedVendors.length !== 0) {
      if (autoVendorApprove !== "") {
        project.autoSelectBid = autoVendorApprove;
      }
      if (bidDueDate !== dateUtil.getDateTimestamp(project.bidDueDate)) {
        project.bidDueDateChanged = true;
        project.bidDueDate = dateUtil.convertToServerDateTsObj(bidDueDate);
      }
      if (deliveryDueDate !== dateUtil.getDateTimestamp(project.deliveryDueDate)) {
        project.deliveryDueDateChanged = true;
        project.deliveryDueDate = dateUtil.convertToServerDateTsObj(deliveryDueDate);
      }
      if (selectedVendors.length > 0) {
        project.preferredVendors = selectedVendors;
      }
      if (bidSelectDeadlineDate !== dateUtil.getDateTimestamp(project.bidSelectDeadlineDate)) {
        project.bidSelectDeadlineDate = dateUtil.convertToServerDateTsObj(bidSelectDeadlineDate);
      }
      project.errors = {};
      project.status = "SUBMITTED_FOR_BIDS";
      var payload = transformBlankToNull(project);
      putAxiosResponse(APIUrls.PROJECT(project.id), payload).then((res) => {
        prop.refresh();
        closePopup();
      });
    }
  };
  $(".cal-firstFocus").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE) {
      if($('div').hasClass('dashCalendarDeadLine')){
        setTimeout(() => {
          toggleCal(false);
          $('.cal-firstFocus').trigger('focus')
          $('.cal-firstFocus').removeClass('cal-firstFocus')
        }, 100);
      }
    }
    if (e.key === Constants.TAB && e.shiftKey) {
      if($('div').hasClass('dashCalendarDeadLine')){
        toggleCal(false);
        $('.cal-firstFocus').trigger('focus')
        $('.cal-firstFocus').removeClass('cal-firstFocus')
      }
    }
  });
  $(".cal-secondFocus").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE) {
      if($('div').hasClass('dashCalendarMachine')){
        setTimeout(() => {
          toggleIntialCalFlag(false)
          $('.cal-secondFocus').trigger('focus')
          $('.cal-secondFocus').removeClass('cal-secondFocus')
        }, 100);
      }
    }
     if (e.key === Constants.TAB && e.shiftKey) {
      if($('div').hasClass('dashCalendarMachine')){
        toggleIntialCalFlag(false)
        $('.cal-secondFocus').trigger('focus')
        $('.cal-secondFocus').removeClass('cal-secondFocus')
      }
    }
  });
  $(document).on("click",".showPopup",function() {
    $(this).addClass('focusAdd');
 });
 $(document).on("click",".close-requestQuote",function() {
   $('.focusAdd').trigger('focus');
   $('.showPopup').removeClass('focusAdd');
 });
  useEffect(()=>{
    $.each($('.react-calendar__tile'), function( index, value ) {
      $(value).attr('aria-label', value.children[0].ariaLabel);
    });
  });

  const GetBidSelectionDeadlineDate = () => {
    let deadlineDate;
    let timeLabel;
    if(bidSelectDeadlineDate) {
      deadlineDate = dateUtil.format(bidSelectDeadlineDate, null, null);
      timeLabel = dateUtil.getTimeDropdownVal(bidSelectDeadlineDate).label
    }
    return `${deadlineDate} at ${timeLabel}`;
  }

  const deliveryTimeOptions = () => {
    const timeList = JSON.parse(JSON.stringify(TIME_LIST));
    return timeList.map((option) => {
      if(option.value >= 0 && moment(deliveryDueDate).isSame(bidDueDate, 'day') && option.value < bidDueTime + 4) {
        option.isDisabled = true;
      }
      return option;
    });
  }

  return (
<div id="editProjectDatesPopup" className="lightbox-panel bid-extended modelPopup"
  aria-labelledby={(projectStatus.status.code === "bid_selection_expired") ? "editProjectDates" :
  (project.status.code === "all_bids_rejected" || project.status.code === "no_bids_submitted") ? "updateProjectDates" : "extendDeadline"}
  aria-modal="true" role="dialog" onKeyDown={(e)=>updateAgain(e)}>
      <div className="inner-lightbox-panel">
        <div className="modal-header flex">
       { (() => {
            if (isBiddingEnabled()) {
              if (projectStatus.status.code === "bid_selection_expired") {
                return<h5 id="editProjectDates">Edit Project Dates</h5>;
              } else {
                if (
                  project.status.code === "all_bids_rejected" ||
                  project.status.code === "no_bids_submitted"
                ) {
                  return<h5 id="updateProjectDates">Update Project Dates to Request Quote Again</h5>;
                } else {
                  <h5 id="extendDeadline">Extend the Quote Selection Deadline</h5>;
                }
              }
            } else if (project.projectVendorType === "EXTERNAL_BIDLESS") {
              return<strong>Request Translation Again</strong>;
            } else {
              return<strong>Request Translation Again</strong>;
            }
          })()}
          <button id="close" className="close close-requestQuote" aria-label="close" onClick={closePopup}>
            {CrossIconForModal}
          </button>
        </div>
        <div className="lightbox-content vender-form-block ">
        { (() => {
            if (isBiddingEnabled()) {
              if (projectStatus.status.code === "bid_selection_expired") {
                return <p>
                  Your project's quote selection expired on{" "}
                  <b>
                    <DateFormat date={bidDueDate} format={DATE_FORMATS.DATE_TIME} timezone={null}/>
                  </b>
                  <br />
                  Please set new dates for your project to request the vendors to resubmit their quotes.
                </p>;
              } else {
                if ( project.status.code === "all_bids_rejected" || project.status.code === "no_bids_submitted") {
                  return <p>
                    Changing the project dates will require Vendors to provide
                    new bids, and all submitted bids will be removed. If you do
                    not want to restart quotation, click "Cancel". Otherwise,
                    click "Confirm" and vendors will be notified of your changes.
                  </p>;
                }
              }
            } else if (project.projectVendorType === "EXTERNAL_BIDLESS") {
              return <p>
                The vendor has rejected your request. You can choose to request
                translation again from the same or a different vendor.
              </p>;
            } else {
              return <p>
                The internal translator has rejected your request. You can
                choose to request translation again from the same or a different
                internal translator.
              </p>;
            }
          })()}
          <div className="vender-outer">
            <div className="head flex-center">
              <h6 id="selectVendor"> Vendors to Request Quotes From</h6>
            </div>
            <div className="translate-box flex" role="group" aria-labelledby="selectVendor">
              {preferedVendors.map((vendor, index) => {
                return (
                  <div className="translate-box-list" key={index}>
                    <Link aria-checked="false" to="#" aria-label={vendor.label} aria-describedby="selectVendorError" role="checkbox" onClick={() => selectVendor(vendor.value)}>
                      <span>{vendor.label}</span>
                      {selectedVendors.some(
                        (selectedVendor) => selectedVendor.id === vendor.value.id ) ? (SuccessTick) : null}
                    </Link>
                  </div>
                );
              })}
            </div>
            {errorData.vendor !== "" && errorData.length !== 0 && selectedVendors.length === 0 ? (
              <div className="error" id="selectVendorError">Select at least one Vendor</div>
            ) : null}
            <div className="text">
              <span>Your request will be sent to:</span>
              {selectedVendors.length > 0 ? (
                selectedVendors.map((vendor, index) => {
                  if (selectedVendors.length === index + 1) {
                    return <b key={index}>{vendor.name}</b>;
                  } else {
                    return <b key={index}>{vendor.name}, </b>;
                  }
                })
              ) : (
                <p>You have not selected any vendor yet.</p>
              )}
            </div>
          </div>
          <b>
            {allowAutomaticSelect ? "Automatically approve quote?" : "2. Automatically approve quote?"}
          </b>
          <p>
            Select the option below to have the quote submitted by the vendor
            automatically approved. This option is only available when the
            project is sent to only one of your preferred vendors listed above.
          </p>
          <div className="form-check">
            <input className="form-check-input" type="checkbox" name="checkbox" value="" id="autoApproveBid"
              disabled={!( selectedVendors.length === 1 && selectedVendors.length !== 0 ) || autoVendorsSelected }
              onChange={(e) => autoBidApproveSelect(e)} checked={ autoVendorApprove !== "" ? autoVendorApprove : project.autoVendorsSelected }
            />
            <label className="form-check-label" htmlFor="autoApproveBid">
              Yes - automatically approve the quote{" "}
              {selectedVendors.length === 1 ? `submitted by ${selectedVendors[0].name}` : ""}
            </label>
          </div>
          <div className="flex wrap-dropdown wrap-group-dropdown" >
            <div className="global-dropdown-block flex-center firstCal">
              <label htmlFor="cal-firstFocus">Vendors must submit quotes by </label>

              <div className="flex-center w-d100">
                <div className="global-dropdown-select">
                  <button id='cal-firstFocus' type="button" onClick={(e) => { showCalendarDueDate(e); }} ref={refToggle} className="drop-down-btn gb-dropBtn"
                    aria-expanded={toggle ? 'true':'false'} aria-label={toggle ? 'choose date dialog': dateUtil.format(bidDueDate, null, null) } aria-describedby="dateRequired" >
                    <span aria-hidden="true">
                      <DateFormat date={bidDueDate} timezone={null}/>
                    </span>
                    {calenderIcon}
                  </button>
                </div>
                {toggle ? (
                  <div ref={refCalendar} onKeyDown={(e) => { closeCalendar(e); }} >
                    <DatePickerCalendar className="dashCalendarDeadLine"
                        minDate={new Date()}
                        value={ new Date(bidDueDate)}
                        selectDate={bidDueDateChangeHandler} />
                  </div>
                ) : ( "" )}
                <div className="global-dropdown-select small-dropdown-select">
                  <Select className="" classNamePrefix="cw" aria-label="What Time?" menuShouldScrollIntoView={false}
                          options={TIME_LIST}
                          value={dateUtil.getTimeDropdownVal(bidDueTime)}
                          onChange={bidDueTimeChangeHandler}/>
                </div>
              </div>
              {errorData.bidDueDate !== "" && errorData.length !== 0 ? (
                <div id="dateRequired" className="error mb-0" style={{ color: "#BD0B0B" }}>
                  {" "}
                  date is required field
                </div>
              ) : null}
            </div>
          </div>{" "}
          <div className="flex wrap-dropdown wrap-group-dropdown">
            <div className="global-dropdown-block flex-center caltopset">
              <label htmlFor="cal-secondFocus">I need initial translation by</label>
              <div className="flex-center w-d100">
                <div className="global-dropdown-select" aria-label="I need initial translation by" >
                  <button id='cal-secondFocus' onClick={(e) => { showCalendarDeliveryDate(e); }} ref={refToggle2} type="button" className="drop-down-btn gb-dropBtn"
                    aria-expanded={toggleIntialCal ? 'true':'false'} aria-label={toggleIntialCal ? 'choose date dialog':
                    dateUtil.format(deliveryDueDate, null, null) } aria-describedby="dueDateRequired" >
                    <span aria-hidden="true">
                      <DateFormat date={deliveryDueDate} timezone={null}/>
                    </span>
                    {calenderIcon}
                  </button>
                </div>
                {toggleIntialCal ? (
                  <div ref={refCalendar2} onKeyDown={(e) => { closeCalendar(e); }} >
                    <DatePickerCalendar className={receiveQuotes ? "dashCalendarMachine" : " dashCalendarDeadLine"}
                                        value={new Date(deliveryDueDate)}
                                        minDate={new Date(minDeliveryDueDate)}
                                        selectDate={setDeliveryDate}/>
                  </div>
                ) : ( "" )}
                <div className="global-dropdown-select small-dropdown-select">
                  <Select classNamePrefix="cw" aria-label="What Time?" menuShouldScrollIntoView={false}
                          options={deliveryTimeOptions()}
                          value={dateUtil.getTimeDropdownVal(deliveryDueTime)}
                          onChange={deliveryDueTimeChangeHandler}
                          isOptionDisabled={(option) => option.isDisabled}
                          styles={disabledSelectStyle}/>
                </div>
              </div>
              {errorData.deliveryDueDate !== "" && errorData.length !== 0 ? (
                <span className="error" id="dueDateRequired" style={{ color: "#BD0B0B" }}>delivery due date is required field</span>
              ) : null}
            </div>
          </div>
          <div className="">
            <strong>You will have to select the quote by:</strong>
            <p>
              <GetBidSelectionDeadlineDate />
            </p>
          </div>
        </div>
        <div className="modal-footer flex">
          <button id="cancelProjectDateBid" className="btn btn-bold close-requestQuote" onClick={closePopup}>
            Cancel
          </button>
          <button id="confirmProjectDateBid" className="btn btn-bold active" onClick={updateBidDate} disabled={checkUpdateBidDateDisabledCondition(project,bidDueDate,deliveryDueDate) ? true : false}>
            Confirm 
          </button>
        </div>
      </div>
    </div>
  );
}
